import React from "react";
import Workspace from "../../components/Workspace/Workspace";

export default function WorkspacePage() {
  return (
    <div>
      <Workspace></Workspace>
    </div>
  );
}
